import { render } from "./ConfirmDeleteAgent.vue?vue&type=template&id=5a7f6033&scoped=true"
import script from "./ConfirmDeleteAgent.vue?vue&type=script&lang=js"
export * from "./ConfirmDeleteAgent.vue?vue&type=script&lang=js"

import "./ConfirmDeleteAgent.vue?vue&type=style&index=0&id=5a7f6033&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a7f6033"]])

export default __exports__